import Cookies from 'js-cookie';
import { getElements } from 'js-utils/src/selector';
import { onCssAnimationEnd } from 'js-utils/src/animation';

import init from '../../common/base/init';

init(() => {
  const closeBtns = getElements('.welcomebar__ctas__close');
  if(!closeBtns.length) return;

  closeBtns.forEach((closeBtn) => {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const container = closeBtn.closest('.welcomebar');
      Cookies.set('welcomebar_closed', container.getAttribute('data-welcomebar-id'), { expires: 365 });

      onCssAnimationEnd(container, () => container.parentNode.removeChild(container));
      container.classList.add('--hide');
    });
  });
});
